<template>
    <base-file-input
        v-model="model"
        v-validate="{
            required: isRequiredByprofileType,
        }"
        :required="isRequiredByprofileType"
        :field="field"
        input-id="visa-page"
        :input-label="labelId"
        :placeholder="
            originalFileName || 'Select scan copy (JPG, PNG, PDF or TIFF file)'
        "
        drop-placeholder="Drop file here..."
        file-type="utility"
        accept="image/*,application/pdf"
        :data-vv-name="labelId"
        :class="{
            'is-invalid': errors.has(labelId),
        }"
        @update:originalFileName="updateOriginalFileName"
    ></base-file-input>
</template>

<script>
import IdentityDocument from './IdentityDocument'
export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {},
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: IdentityDocument, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            default() {
                return {
                    isRequired: true,
                    isLocked: true,
                    key: 'documentInfo.visaPage.fileName',
                    originalFileNameKey:
                        'documentInfo.visaPage.originalFileName',
                }
            },
            required: false,
        },
        profileType: {
            type: String,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        isRequiredByprofileType() {
            // console.log('Profile type on EMirated ID BACK', this.profileType)
            if(this.$route.path.includes('deep-register')) return false
            if (this.profileType == 'Resident Expat') {
                this.field.isRequired = true
                return this.field.isRequired
            } else {
                this.field.isRequired = false
                return this.field.isRequired
            }
        },
        labelId() {
            if(this.$route.name=="self-registration-company-upload-document" || this.$store.getters.form.type=='company')
            {
                if(process.env.VUE_APP_COUNTRY_TEMP=='UK')
                {
                    return "VAT Registration"
                }
                return "Certificate of Incumbency"
            }
            else
            {
                return 'Visa Page Scan Copy'
            }
        }
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
}
</script>
